import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class LoadingSpinnerComponent {
    readonly placeholder = input<string | undefined>(undefined);
    readonly isOverlay = input(false);
}
